<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{ title }}</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn outlined @click.prevent="refresh" :loading="isRefreshing"
            >Refresh</v-btn
          >&nbsp;
          <v-btn
            outlined
            :disabled="!showProcess"
            @click.prevent="process"
            :loading="isProcessing"
            >Process</v-btn
          >&nbsp;
          <v-btn
            outlined
            :disabled="!showProcess"
            @click.prevent="csv"
            :loading="isExporting"
            >CSV</v-btn
          >&nbsp;
          <v-btn outlined v-if="showProcess" @click.prevent="cancel"
            >Cancel</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-select
            :items="getYearRange"
            v-model="selectedYear"
            label="Applicable Year"
          ></v-select>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
          <v-text-field
            v-model="payrollYear"
            label="Payroll Year"
            v-mask="'####'"
          ></v-text-field>
        </v-col>
      </v-row>
      <pay-loc-pagination
        :show-dense="false"
        :headers="payLocHeaders"
        :show-select="true"
        v-if="employees.length <= 0"
        :by-user="true"
      ></pay-loc-pagination>
      <!-- <v-data-table :items="employees" :headers="employeesH" v-if="employees.length > 0"></v-data-table> -->
      <emp-list
        :show-dense="false"
        :headers="employeesH"
        :items="employees"
        :show-select="true"
        v-if="employees.length > 0"
      ></emp-list>
    </v-container>
  </div>
</template>
<script>
import PayLocPagination from "../../setup/general/payroll-location/PaginationSelection";
import EmpList from "./Employee";
import EventBus from "../../../events/eventBus";
import { mask } from "vue-the-mask";
import userAccessMixin from "../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/autoTaxStatus";
export default {
  metaInfo: {
    title: "Auto Tax Status",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  directives: {
    mask
  },
  data: () => ({
    title: "Auto Tax Status",
    classPadding: "my-0 py-0",
    selectedYear: new Date().getFullYear(),
    payrollYear: new Date().getFullYear(),
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId"
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName"
      }
    ],
    selectedPayLoc: [],
    employees: [],
    employeesH: [
      {
        text: "",
        sortable: false,
        value: "actions"
      },
      {
        text: "Emp Code",
        align: "left",
        sortable: false,
        value: "empCode"
      },
      {
        text: "Employee Name",
        align: "left",
        sortable: false,
        value: "empName"
      },
      {
        text: "Tax Status",
        align: "left",
        sortable: false,
        value: "prevTaxCode"
      },
      {
        text: "New Tax Status",
        align: "left",
        sortable: false,
        value: "newTaxCode"
      }
    ],
    isRefreshing: false,
    selectedEmployee: [],
    isProcessing: false,
    isExporting: false
  }),
  components: {
    PayLocPagination,
    EmpList
  },
  computed: {
    getYearRange() {
      var currentYear = new Date().getFullYear(),
        years = [];
      let startYear = currentYear - 3;
      let endYear = currentYear + 3;
      while (endYear >= startYear) {
        years.push(endYear--);
      }
      return years;
    },
    showProcess() {
      return this.employees.length > 0 ? true : false;
    }
  },
  methods: {
    refresh() {
      this.isRefreshing = true;
      var data = {
        LocIDs: this.selectedPayLoc,
        Year: this.selectedYear,
        PayrollYear: this.payrollYear
      };
      this.$axios
        .post(`${API_ENDPOINT}/refresh`, data)
        .then(({ data }) => {
          this.employees = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isRefreshing = false;
        });
    },
    cancel() {
      this.employees = [];
      this.selectedPayLoc = [];
    },
    process() {
      this.isProcessing = true;
      var data = {
        Details: this.selectedEmployee,
        Year: this.selectedYear,
        PayrollYear: this.payrollYear
      };
      this.$axios
        .post(`${API_ENDPOINT}/process`, data)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.cancel();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    csv() {
      var data = {
        Details: this.selectedEmployee
      };
      this.isExporting = true;
      this.$axios
        .post(`${API_ENDPOINT}/export`, data)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;
          // var newSubPath = "";
          // if (subPath.length > 1) {
          //   newSubPath = subPath.slice(0, -1);
          // } else {
          //   newSubPath = subPath.slice(0, -1);
          // }
          // window.open(`${subPath.slice(0, -1)}${API_ENDPOINT}/export/${data}`);
          var nameOfTheCsv = "TaxStatusList.xlsx";
          this.$axios
            .get(`${API_ENDPOINT}/export/${data}`, {
              responseType: "blob",
            })
            .then((response) => {
              const downloadUrl = window.URL.createObjectURL(
                new Blob([response.data])
              );
              const link = document.createElement("a");
              link.href = downloadUrl;
              link.setAttribute("download", nameOfTheCsv);
              document.body.appendChild(link);
              link.click();
              link.remove();
            })
            .catch((err) => console.log(err));
          //this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isExporting = false;
        });
    }
  },
  mounted() {
    EventBus.$on("SELECTED_PAYLOC", val => {
      //this.selectedPayLoc = val;
      var locIds = val.map(function(item) {
        return item.locId;
      });

      this.selectedPayLoc = locIds;
    });

    EventBus.$on("SELECTED_EMP_AUTOTAX", val => {
      this.selectedEmployee = val;
    });
  },
  created() {
    this.getUserAccessRights("AUTOTXSTAT");
  }
};
</script>